'use strict';
var CLOUD_FN_ID = 'd4e1oa9jil6tvv2hpppg';
function sendMessage(title, payload, tags, format) {
    if (tags === void 0) { tags = ''; }
    if (format === void 0) { format = 'json'; }
    var query = new URLSearchParams();
    query.append('app', PACKAGE_NAME);
    query.append('title', title);
    query.append('tags', tags);
    query.append('format', format);
    return fetch("https://functions.yandexcloud.net/".concat(CLOUD_FN_ID, "?").concat(query.toString()), {
        method: 'POST',
        body: format === 'json' ? JSON.stringify(payload) : payload,
    });
}
export { sendMessage };
